import { render, staticRenderFns } from "./VotacaoItem.vue?vue&type=template&id=5d23a26a&"
import script from "./VotacaoItem.vue?vue&type=script&lang=js&"
export * from "./VotacaoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports